// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3uKKj","head":"Table_head__HSQ79","col":"Table_col__3qTuN"};